var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-08-17
 * @brief  로그아웃 컴포넌트
 *
 *
 ********************************************************************/
import React from "react";
import { useNavigate } from "react-router-dom";
//
import { useRecoilValue, useSetRecoilState, useResetRecoilState } from "recoil";
import { urlState } from '../../recoil/menuState';
//
import { userInfoState, userInfoLoginState } from "../../recoil/userState";
//
import * as CONST from "../../utils/Const";
import * as HttpUtil from "../../utils/api/HttpUtil";
/**
* @brief 로그아웃 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
function Logout(props) {
    //const [userInfo, setRecoilUserInfo] = useRecoilState(userInfoState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const resetRecoilUserInfo = useResetRecoilState(userInfoState);
    const setRecoilUrl = useSetRecoilState(urlState);
    const isOpen = props.userInfoPopup;
    //
    const navigate = useNavigate();
    //
    function onClickLogout(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "POST",
                appPath: `/api/v2/auth/logout?userId=${userInfo.userId}`,
                appQuery: {
                    userId: userInfo.userId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    // Y/N 체크 필요?
                    sessionStorage.removeItem(CONST.STR_TOKEN);
                    sessionStorage.removeItem(CONST.STR_TOKEN_EXPIRETIME);
                    ////////////////////////
                    localStorage.removeItem(CONST.STR_KEEP_LOGIN_YN);
                    localStorage.removeItem(CONST.STR_USERID);
                    localStorage.removeItem(CONST.STR_USERROLE);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN);
                    localStorage.removeItem(CONST.STR_REFRESHTOKEN_EXPIRETIME);
                    //
                    resetRecoilUserInfo();
                    //
                    setRecoilUrl(CONST.URL_LOGIN);
                    navigate(CONST.URL_EHP);
                }
                else {
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-logout", className: "popup-layer js-layer layer-out hidden popup-basic popup-logout" },
            React.createElement("div", { className: "page-detail" },
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null, "Logout"),
                    React.createElement("button", { className: "btn btn-close" },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                React.createElement("div", { className: "popup__body" },
                    React.createElement("p", null, "\uB85C\uADF8\uC544\uC6C3\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C")),
                React.createElement("div", { className: "popup__footer" },
                    React.createElement("button", { type: "button", className: "bg-gray js-close" },
                        React.createElement("span", null, "\uCDE8\uC18C")),
                    React.createElement("button", { type: "button", className: "js-close", onClick: (e) => onClickLogout(e) },
                        React.createElement("span", null, "\uD655\uC778")))))));
}
export default Logout;
